import { type IntlShape } from 'react-intl'
import { ZIP_CODE_RANGE_OPERATOR, ZipCodeRange } from 'typings'
import { create, each, enforce, omitWhen, test } from 'vest'
import { type FormType } from './Editor'
import { messages } from './messages'

const CHARS_TO_IGNORE = /[\s-]+/g

type SuiteParams = {
  intl: IntlShape
}

function isUnique(range: ZipCodeRange, ranges: ZipCodeRange[]) {
  return (
    ranges.filter((r) => r.from === range.from && r.to === range.to).length ===
    1
  )
}

export const suite = ({ intl }: SuiteParams) =>
  create('shippingLocation', ({ zipCodeRanges }: FormType) => {
    const { $t } = intl

    const onlyOneField = zipCodeRanges.length === 1

    each(zipCodeRanges, (range, index) => {
      omitWhen(!range.from && !range.to && onlyOneField, () => {
        test(
          `zipCodeRanges.${index}.from`,
          $t(messages.validation.required),
          () => {
            enforce(range.from).isNotEmpty()
          }
        )

        test(
          `zipCodeRanges.${index}.to`,
          $t(messages.validation.required),
          () => {
            enforce(range.to).isNotEmpty()
          }
        )

        test(
          `zipCodeRanges.${index}.operator`,
          $t(messages.validation.required),
          () => {
            enforce(range.operator).isValueOf(ZIP_CODE_RANGE_OPERATOR)
          }
        )

        test(
          `zipCodeRanges.${index}.to`,
          $t(messages.validation.endGreatherThanStart),
          () => {
            const from = range.from.replace(CHARS_TO_IGNORE, '')
            const to = range.to.replace(CHARS_TO_IGNORE, '')

            enforce(to).condition((to) => to >= from)
          }
        )

        test(
          `zipCodeRanges.${index}.from`,
          $t(messages.validation.duplicated),
          () => {
            enforce(range).condition((range) => isUnique(range, zipCodeRanges))
          }
        )

        test(
          `zipCodeRanges.${index}.to`,
          $t(messages.validation.duplicated),
          () => {
            enforce(range).condition((range) => isUnique(range, zipCodeRanges))
          }
        )
      })
    })
  })
